import React from 'react';

import Hero from './Hero/Hero';
import SnakeSteps from './SnakeSteps/SnakeSteps';
import AnimationLayer from './AnimationLayer/AnimationLayer';
import { sectionIds } from '../../../utils/constants';
import { AccessibilityModeEnum, PagesEnum } from '../../../utils/enums';
import { useAccessibility } from '../../../contexts/AccessibilityContext';

const AnimationSection = () => {
  const {
    settings: { mode },
  } = useAccessibility();

  return (
    <section className='animation-section' id={sectionIds[PagesEnum.School].hero}>
      {mode !== AccessibilityModeEnum.Enhanced && <AnimationLayer />}
      <Hero />
      <SnakeSteps />
    </section>
  );
};

export default AnimationSection;
